import { useState, useEffect } from 'react'

export const useInputState = (initialValue: string | number = '') => {
  const [value, setValue] = useState(initialValue ?? '')
  const [lastValidValue, setLastValidValue] = useState(initialValue ?? '')
  const [error, setError] = useState<string | null>(null)
  const [isEscapePressed, setIsEscapePressed] = useState(false)

  useEffect(() => {
    if (initialValue != null) {
      setValue(initialValue)
      setLastValidValue(initialValue)
    }
  }, [initialValue])

  const handleEscape = () => {
    setIsEscapePressed(true)
    setValue(lastValidValue)
    setError(null)
  }

  const resetEscapeState = () => {
    setIsEscapePressed(false)
  }

  return {
    value,
    setValue,
    lastValidValue,
    setLastValidValue,
    error,
    setError,
    isEscapePressed,
    handleEscape,
    resetEscapeState
  }
}
